import { IonAlert, useIonToast } from "@ionic/react";
import { useContext, useEffect, useState } from "react";
import invoicePattern from "../pages/Invoice/InvoicePattern";
import invoicePatternGST from "../pages/Invoice/InvoicePatternGST";
import { APPLINKS } from "../resources/AppConst";
import db from "../resources/db";
import { useRouter } from "../resources/Hooks";
import { ConfigContext } from "./ConfigContext";

export function useInvoiceList() {
    
    const { getInvoices } = useContext(ConfigContext)

    const [Invoices, setInvoices] = useState([])
    const [InvList, setInvList] = useState([])
    const [showLoading, setShowLoading] = useState(true);

    const router = useRouter();
    const [presentToast, dismissToast] = useIonToast();
    

    useEffect(() => {
        getInvoices().then(res => {
            setInvoices(res)
            setInvList(res)
            setShowLoading(false)
        })
        return () => {
            setInvoices([])
            setInvList([])
        }
    }, [getInvoices]);

    

    /** View Bill / Invoice
     * @param invoice
     */
    const viewBill = (invoice) => {
        const url = APPLINKS.invoice + `/${invoice.id}`;
        router.history.push(url);
    }

    const editBill = (invoice) => {
        const url = APPLINKS.edit + `/${invoice.id}`
        router.history.push(url)
    }

    /** Print Bill / Invoice
     * @param invoice
     */
    const printBill = (invoice) => {
        console.log(invoice);

        let print = document.getElementById('print').contentWindow;
        invoice.gstEnabled ?
            print.document.write(invoicePatternGST(invoice))
            : print.document.write(invoicePattern(invoice))
        print.document.close();
        print.focus();
        print.print();
    }

    /** Remove Bill / Invoice by id
     * @param id
     */
    const removeBill = (id) => {
        db.invoices.delete(id).then((res) => {
            presentToast({
                message: "Invoice Deleted",
                color: 'danger',
                duration: 2000,
                buttons: [
                    {
                        text: 'OK',
                        role: 'cancel',
                        handler: () => {
                            dismissToast();
                        }
                    }
                ]
            });
            console.log("Bill Removed", res);
        })
        getInvoices().then((res) => {
            setInvoices(res)
            setInvList(res)
        })
    }


    return {
        Invoices, setInvoices,
        InvList, setInvList,
        showLoading, setShowLoading,
        viewBill,
        editBill,
        printBill,
        removeBill
    }
}